import React from 'react';
import { Link } from 'react-router-dom';

interface BuildingBillsProps {
  buildingId: string;
}

const BuildingBills: React.FC<BuildingBillsProps> = ({ buildingId }) => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-medium text-gray-900">Recent Bills</h3>
        <Link
          to={`/dashboard/bills/new?building=${buildingId}`}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none"
        >
          Add Bill
        </Link>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <p className="p-4 text-center text-gray-500">No bills have been recorded yet.</p>
      </div>
      
      <div className="mt-4 text-right">
        <Link
          to={`/dashboard/bills?building=${buildingId}`}
          className="text-sm font-medium text-primary-600 hover:text-primary-500"
        >
          View all bills →
        </Link>
      </div>
    </div>
  );
};

export default BuildingBills;
